export const EXTERNAL_POINT_OF_SALE = 'External Point of Sale'
export const WS_EXTERNAL_BOUTIQUE = 'WS-External Boutique'
export const WS_EXTERNAL_BOUTIQUE_ALT = 'WS_External_Boutique'
export const ABBREVIATION_MAISON = {
  CAR: 'CA',
  JLC: 'JL',
  VCA: 'VC',
  IWC: 'IW',
  PAN: 'PA',
  VAC: 'VA',
  RDU: 'RD',
  DUN: 'DU',
  PIA: 'PI',
  MTB: 'MB',
  CHL: 'CH',
  AAL: 'AA',
  ALS: 'LS',
  BEM: 'ΒΜ'
}

export const isRetailer = boutique => {
  return (
    boutique.boutiqueType === EXTERNAL_POINT_OF_SALE &&
    boutique.wholesalerCustomerGroup !== WS_EXTERNAL_BOUTIQUE &&
    boutique.wholesalerCustomerGroup !== WS_EXTERNAL_BOUTIQUE_ALT
  )
}

export const sha256 = async message => {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message)

  // hash the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  // convert bytes to hex string
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}
